<app-form-group>    
    <ng-container *ngIf="availableBases.length > 0; else second" class="text-standard">
        <label >Välj en eller flera grunder för behörighet</label>
    </ng-container>
    <ng-template #second>
        <ng-container *ngIf="availableBases.length == 0">
            <label >För att kunna ansöka om denna behörighet behöver du vara född senast 1 juli 1958 och kunna visa att du har lång erfarenhet av undervisning. 
                Det är inte möjligt att ansöka om denna behörighet utifrån andra grunder.<br> 
                <a target="_blank" href="https://www.skolverket.se/regler-och-ansvar/lararlegitimation-och-forskollararlegitimation/regler-och-krav-for-lararlegitimation/larar--och-forskollararlegitimation-och-krav-for-att-fa-behorighet#h-Behorighetutoverdinexamen">
                    Läs mer om krav för att få behörighet att undervisa här.</a>
            </label>
        </ng-container>
    </ng-template> 
    
    <ng-container *ngFor="let basis of availableBases">
        <app-checkbox [control]="toControl(basis)"> {{basis.typeName}}</app-checkbox>
        <div *ngIf="showYearIntervals(basis)" class="year-interval">
            <label class="text-standard">Välj vilka årskurser behörigheten gäller</label>
            <app-checkbox *ngFor="let interval of basis.yearIntervals" [control]="toIntervalControl(basis, interval)">
                {{interval}}
            </app-checkbox>
        </div>
        <div *ngIf="showYearFreeMax(basis)" class="year-interval">
            <div class="responsive-cols">
                <div>
                    <app-select [control]="toFromYearControl(basis)" label="From åk" data-test-id="fromYear">
                        <option *ngFor="let year of fromYears(basis)">{{year}}</option>
                    </app-select>
                </div>
                <div>
                    <app-select [control]="toToYearControl(basis)" label="Tom åk" data-test-id="toYear">
                        <option *ngFor="let year of toYears(basis)">{{year}}</option>
                    </app-select>
                </div>
            </div>
        </div>
    </ng-container>    
</app-form-group>